import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_HEADER_VIEW_ACTION_TYPE } from '../actions';

const initialState = {};

const loanHeaderViewsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_HEADER_VIEW_ACTION_TYPE.DELETE_LOAN_HEADER_VIEW:
      return _.omit(state, [payload]);
    case LOAN_HEADER_VIEW_ACTION_TYPE.GET_LOAN_HEADER_VIEW:
      return payload || state;
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default loanHeaderViewsReducer;
